
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { Form, Modal, Radio, Switch } from 'antd';
import { DrawerPanelTitle, modalPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';


export const EditReportDefinitionModal = (props: { scheduleReport: any, onFinish: any, onChange: any }) => {
    
    const schedule = props.scheduleReport.scheduled;
    const [form] = Form.useForm();
    const { projectGroup } = useAuth();            

    const onFormFinish = async (values: any) => {
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/scheduledReports/${props.scheduleReport.id}`, { 
            method: 'PUT', 
            data: {
                enabled: values.enabled,
                schedule_type: values.schedule_type,
            },
        });
        props.onChange();
    }    

    const initValues = {
        enabled: schedule?.enabled,
        schedule_type: schedule?.schedule_type || 'weekly',
    };
        
    return (
        <Modal
            open={true}
            onOk={() => form.submit()}
            onCancel={props.onFinish}
            afterClose={form.resetFields}
            {...modalPanelStyles}
            title={<DrawerPanelTitle title="Definir Informe" />}
        >
            <Form 
                layout='horizontal' 
				labelAlign='right'
                form={form} 
                onFinish={onFormFinish} 
                initialValues={initValues}
            >                
                <Form.Item name='schedule_type' label="Tipo">
                    <Radio.Group>       
                        <Radio value='weekly'> Semanal</Radio>
                        <Radio value='monthly'> Mensual </Radio>                        
                    </Radio.Group>
                </Form.Item>

                <Form.Item 
                    name='enabled' 
                    label="Estado"
                    valuePropName="checked"
                >
                    <Switch checkedChildren="Automatizado" unCheckedChildren="Sin automatizar" />
                </Form.Item>
            </Form>     
        </Modal>
    );
};
